module.exports = __webpack_public_path__ + "components/flag/static/square/qa-c533c69159703c21c34e1010bac8710b.svg";